const rates = {
  forms: {
    information: {
      details: {
        fields: {
          supplierId: {
            name: 'ציים',
          },
        },
      },
    },
  },
};

export default rates;
